import {
  archiveMimeTypes,
  audioMimeTypes,
  codeMimeTypes,
  documentMimeTypes,
  fontMimeTypes,
  imageDocumentMimeTypes,
  imageMimeTypes,
  otherMimeTypes,
  videoMimeTypes,
} from './mime-data.ts'
import {
  type FileContentType,
  type FileExtension,
  archiveFileContentTypes,
  archiveFileExtensions,
  audioFileContentTypes,
  audioFileExtensions,
  codeFileContentTypes,
  codeFileExtensions,
  documentFileContentTypes,
  documentFileExtensions,
  fontFileContentTypes,
  fontFileExtensions,
  imageDocumentFileContentTypes,
  imageDocumentFileExtensions,
  imageFileContentTypes,
  imageFileExtensions,
  otherFileContentTypes,
  otherFileExtensions,
  videoFileContentTypes,
  videoFileExtensions,
} from './mime-types.ts'

type FileKindRecord<
  ContentType extends FileContentType,
  Extension extends FileExtension,
> = Record<
  string,
  {
    contentTypes: Array<ContentType>
    description: string
    extensions: Array<Extension>
    map: Partial<Record<ContentType, Array<Extension>>>
  }
>

export const FileKindInfo = {
  document: {
    contentTypes: documentFileContentTypes,
    description: 'Documents',
    extensions: documentFileExtensions,
    map: documentMimeTypes,
  },
  archive: {
    contentTypes: archiveFileContentTypes,
    description: 'Archives',
    extensions: archiveFileExtensions,
    map: archiveMimeTypes,
  },
  audio: {
    contentTypes: audioFileContentTypes,
    description: 'Audio',
    extensions: audioFileExtensions,
    map: audioMimeTypes,
  },
  code: {
    contentTypes: codeFileContentTypes,
    description: 'Code',
    extensions: codeFileExtensions,
    map: codeMimeTypes,
  },
  font: {
    contentTypes: fontFileContentTypes,
    description: 'Fonts',
    extensions: fontFileExtensions,
    map: fontMimeTypes,
  },
  image: {
    contentTypes: imageFileContentTypes,
    description: 'Images',
    extensions: imageFileExtensions,
    map: imageMimeTypes,
  },
  image_document: {
    contentTypes: imageDocumentFileContentTypes,
    description: 'Image Documents',
    extensions: imageDocumentFileExtensions,
    map: imageDocumentMimeTypes,
  },
  other: {
    contentTypes: otherFileContentTypes,
    description: 'Other',
    extensions: otherFileExtensions,
    map: otherMimeTypes,
  },
  raw: {
    contentTypes: [],
    description: '',
    extensions: [],
    map: {},
  },
  unknown: {
    contentTypes: [],
    description: '',
    extensions: [],
    map: {},
  },
  video: {
    contentTypes: videoFileContentTypes,
    description: 'Video',
    extensions: videoFileExtensions,
    map: videoMimeTypes,
  },
} as const satisfies FileKindRecord<FileContentType, FileExtension>

export type FileKind = keyof typeof FileKindInfo
